// @flow
import * as React from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// $FlowFixMe[missing-export] exposed only for TS or js
import { selectHelpdeskNewRequestUrl } from '@gandi/authentication';
import {
  selectIsFailureCartOwnerList,
  deleteCart,
  resetCart,
} from '@gandi/cart';
import { notifyDanger, notifySuccess } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

export function useConflictInfo(): {
  failureCartOwners: boolean | number,
  supportURL: string,
} {
  const { __ } = useTranslator();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [deleting, setDeleting] = React.useState(false);

  const failureCartOwners = useAppSelector(state =>
    selectIsFailureCartOwnerList(state),
  );

  const supportURL = useAppSelector(selectHelpdeskNewRequestUrl);

  React.useEffect(() => {
    // When using a hook conditionnally, place the condition *inside*
    // the hook as hooks must always be called in the same order.
    // (eslint react-hooks/rules-of-hooks)
    let el;
    let handleDeleteClick;
    if (!global.__SERVER__) {
      handleDeleteClick = async (evt: any) => {
        evt.preventDefault();
        if (deleting) {
          return;
        }

        setDeleting(true);
        try {
          await dispatch(deleteCart());
          dispatch(resetCart());
          dispatch(
            notifySuccess({
              message: __('Order cancelled successfully.'),
            }),
          );
          navigate('/cart/overview');
        } catch (err) {
          dispatch(
            notifyDanger({
              message: err._error || __('Unable to cancel this order.'),
            }),
          );
          setDeleting(false);
        }
      };
      el = document.getElementById('delete-cart');
      if (el) {
        el.addEventListener('click', handleDeleteClick);
      }
    }
    return () =>
      el ? el.removeEventListener('click', handleDeleteClick) : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    failureCartOwners,
    supportURL,
  };
}
